/**
 * This code runs on every page on the front-end. If something should only run in a 1-2 places
 * consider creating a new script and conditionally loading it from src/Assets/FrontEnd.php
 */


import MobileNav from './MobileNav';

 jQuery(document).ready(function($) {
  var select = require('select2');
  var objectFitImages = require('object-fit-images');
  var newNav = new MobileNav();

  objectFitImages();

// Nav Desktop Dropdowns
  function nestedAccordionStyleNav() {
    var nestedElements = $('.menu-item-has-children > a');
    nestedElements.on('click', function(e) {
      e.preventDefault();
      var others = nestedElements.not($(this));
      var isOpen = others.hasClass('collapsed');
      others.removeClass('collapsed', isOpen);
      others.next().removeClass('collapsed', isOpen);
      $(this).toggleClass('collapsed');
      $(this).next().toggleClass('collapsed');
    });
  };
  nestedAccordionStyleNav();

  function sitesNav() {
    var selectors = $('.sites-nav, span.sites-header, .nested-items');
    var target = $('.sites-nav');
    target.on('click', function() {
      var isOpen= target.hasClass('open');
      selectors.toggleClass('open', !isOpen);
    });
  }
  sitesNav();

});


